import { createContext } from 'react';

import DataAccess from './DataAccess';

export const DataAccessContext = createContext<{
  dataAccess: DataAccess;
}>({
  dataAccess: null,
});
